export enum FilterExpressionType {
    equals = "equals",
    contains = "contains",
    lessThan = "lessThan",
    greaterThan = "greaterThan",
    isTrue = "isTrue",
    isFalse = "isFalse",
    isNull = "isNull",
    isNotNull = "isNotNull"
}
